// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import EmentorArray from '../shared/EmentorArray';

const ConstructedResponse = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Prompt" instructions="What is the constructed response prompt?" />
      <Controller
        control={control}
        name="content.core.prompt"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.prompt} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="Response" instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like." />
      <Controller
        control={control}
        name="content.core.response"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.response} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default ConstructedResponse;